/* eslint-disable */
import $ from 'jquery';
export default function customJs() {
  // "use strict";
  var $menu_show = $('.mobile-toggle'),
    $menu = $('header #menu-main'),
    $menu_yoga = $('header .yoga-menu'),
    $list = $('ul.nav-menu li a'),
    $list_firo = $('ul.firo-nav-menu li a'),
    // $menu_list_firo = $("ul.firo-nav-menu li.has-dropdown"),
    // $menu_list = $("header li.has-dropdown"),
    // $menu_ul = $("ul.sub-menu"),
    $cart_model = $('.cart-model'),
    $cart_link = $('#cart-link'),
    $search_bar = $('#search_bar'),
    $search_close = $('.close-search'),
    $search_bot = $('#search-header'),
    $fixed_header = $('#fixed-header'),
    $fixed_header_dark = $('#fixed-header-dark'),
    $fixed_header_light = $('#fixed-header-light');
  // $sticky_content = $(".sticky-content"),
  // $sticky_sidebar = $(".sticky-sidebar");
  $menu_show.on('click', function (e) {
    $menu.slideToggle();
    $menu_yoga.slideToggle();
  });
  $list.on('click', function (e) {
    var submenu = this.parentNode.getElementsByTagName('ul').item(0);
    if (submenu != null) {
      e.preventDefault();
      $(submenu).slideToggle();
    }
  });
  $list_firo.on('click', function (e) {
    var submenu = this.parentNode.getElementsByTagName('ul').item(0);
    if (submenu != null) {
      e.preventDefault();
      $(submenu).slideToggle();
    }
  });
  $(document).on('load', function () {
    $('body').imagesLoaded(function () {
      $('.nile-preloader').fadeOut();
    });
  });
  window.$('.animate').scrolla({ once: true, mobile: false });
  var $firo_menu = $('#firo-menu'),
    $open_firo_menu = $('.sidebar-menu-toggle'),
    $close_firo_menu = $('.close-firo-menu');
  $close_firo_menu.on('click', function (e) {
    $firo_menu.slideUp();
  });
  $open_firo_menu.on('click', function (e) {
    $firo_menu.slideDown();
  });
  $cart_link.on('click', function (e) {
    $cart_model.slideToggle('fast');
  });
  $(window).on('click', function (e) {
    $cart_model.hide('fast');
  });
  $cart_link.on('click', function (e) {
    e.stopPropagation();
  });
  $search_bot.on('click', function (e) {
    $search_bar.slideToggle('fast');
  });
  $search_close.on('click', function (e) {
    $search_bar.hide('fast');
  });
  var owl2 = window.$('.slider-1');
  var owl3 = window.$('.travelers-say-3');
  var owl = window.$('.testimonial-carousel');
  var owl_portfolio_1 = window.$('.firo-portfolio-slider-1');
  var owl_portfolio_2 = window.$('.firo-portfolio-slider-2');
  owl.owlCarousel({
    items: 3,
    itemsDesktop: [1000, 3],
    itemsDesktopSmall: [900, 3],
    itemsTablet: [600, 1],
    slideSpeed: 1000,
    autoPlay: true,
    itemsMobile: false
  });
  owl2.owlCarousel({
    items: 1,
    itemsDesktop: [1000, 1],
    itemsDesktopSmall: [900, 1],
    itemsTablet: [600, 1],
    slideSpeed: 1000,
    autoPlay: true,
    itemsMobile: false
  });
  owl_portfolio_1.owlCarousel({
    items: 4,
    itemsDesktop: [1000, 4],
    itemsDesktopSmall: [900, 3],
    itemsTablet: [600, 1],
    slideSpeed: 1000,
    autoPlay: true,
    itemsMobile: false
  });
  owl_portfolio_2.owlCarousel({
    items: 1,
    itemsDesktop: [1000, 1],
    itemsDesktopSmall: [900, 1],
    itemsTablet: [600, 1],
    slideSpeed: 1000,
    autoPlay: true,
    itemsMobile: false
  });
  owl3.owlCarousel({
    dotsContainer: '#carousel-custom-dots',
    items: 3,
    itemsDesktop: [1000, 3],
    itemsDesktopSmall: [900, 3],
    itemsTablet: [600, 1],
    itemsMobile: false
  });
  $(document).on('click', '[data-toggle="lightbox"]', function (event) {
    event.preventDefault();
    $(this).ekkoLightbox();
  });
  $(window).on('scroll', function () {
    if ($(window).scrollTop() >= 50) {
      $fixed_header.addClass('fixed-header');
      $fixed_header_dark.addClass('fixed-header-dark');
      $fixed_header_light.addClass('fixed-header-light');
    } else {
      $fixed_header.removeClass('fixed-header');
      $fixed_header_dark.removeClass('fixed-header-dark');
      $fixed_header_light.removeClass('fixed-header-light');
    }
  });
  $('#search, #search button.close').on('click keyup', function (event) {
    if (event.target === this || event.target.className === 'close' || event.keyCode === 27) {
      $(this).removeClass('open');
    }
  });
  $('form1').submit(function (event) {
    event.preventDefault();
    return false;
  });
  //jQuery("a#yt-preview").YouTubePopUp();
  if ($('.filtr-container')[0]) {
    var $container_in = $('.filtr-container');
    if (typeof $('.filtr-container').filterizr === 'function') {
      $container_in.imagesLoaded(function () {
        //var filterizd = $(".filtr-container").filterizr({});
      });
    }
  }
  //   var wow = new WOW({
  //     boxClass: "wow",
  //     animateClass: "animated",
  //     offset: 0,
  //     mobile: false,
  //     live: true,
  //   });
  //   $(window).imagesLoaded(function () {
  //     wow.init();
  //   });
  $(window).on('scroll', function (e) {
    if ($(this).scrollTop() > 200) {
      $('.go-top').fadeIn(200);
    } else {
      $('.go-top').fadeOut(200);
    }
  });
  $('.go-top').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 300);
  });
}
